import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { URL, ADMIN } from "../../../../lib/lib.js";
import "./component.css";
import { useCallback } from "react";

const Component = ({tableHeading}) => {
  const { hotelId } = useParams();
  const [hotelName, setHotelName] = useState('');
  const [users, setUsers] = useState([]);
  // const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteText, setDeleteText] = useState("");
  const [showDeleteText, setShowDeleteText] = useState("");
  const [userIdToDelete, setUserIdToDelete] = useState(null); // Store user id to delete

  
  const fetchData = useCallback(async () => {
  if (!hotelId) return;

  setLoading(true);
  try {
    const res = await fetch(URL + ADMIN.hotel_table_view, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        hotelId,
        page,
        limit,
        // search,
        sortField,
        sortOrder,
      }),
      credentials: "include",
    });

    const data = await res.json();
    setUsers(data.data || []);
    setHotelName(data.data[0].hotelId?.name);
    setTotal(data.pagination?.totalData || 0);
  } catch (err) {
    console.error("Fetch error:", err);
  } finally {
    setLoading(false);
  }
// }, [hotelId, page, limit, search, sortField, sortOrder]);
}, [hotelId, page, limit, sortField, sortOrder]);

useEffect(() => {
  fetchData();
}, [fetchData]);


  // Show delete confirmation modal
  const handleDeleteClick = (user) => {
    setUserIdToDelete(user._id);
    setShowDeleteText(user._id);
    setShowDeleteModal(true); // Show the modal when delete is clicked
  };


  // Handle the regenerateQRCode
  const handleRegenerateQRCode = async (user) => {
    try {
      const response = await fetch(URL + ADMIN.hotel_table_regenerate, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tableId: user._id }),
        credentials: "include"
      });

      if (response.status === 200) {
        fetchData();
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("Error deleting user");
    }
  };
  
  // Handle the delete confirmation
  const handleDeleteConfirm = async () => {
    if (deleteText === showDeleteText) {
      try {
        const response = await fetch(URL + ADMIN.hotel_table_delete, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ tableId: userIdToDelete }),
          credentials: "include"
        });

        if (response.status === 200) {
          setShowDeleteModal(false);
          fetchData();
          setDeleteText('');
          setShowDeleteText('');
        }
      } catch (error) {
        console.error("Delete error:", error);
        alert("Error deleting user");
      }
    } else {
      alert("Please type 'DELETE' to confirm the deletion.");
    }
  };

  // Cancel the delete operation
  const handleDeleteCancel = () => {
    setShowDeleteModal(false); // Close the modal
    setDeleteText(""); // Clear the input field
  };

  // Handle sorting
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // Calculate total pages
  const totalPages = Math.ceil(total / limit);

  // Disable next and prev buttons if necessary
  const disableNext = page >= totalPages;
  const disablePrev = page <= 1;

  return (
    <div className="padd-dash">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <h3 className="head-dash mb-0">{hotelName} {tableHeading}</h3>
        <div className="d-flex gap-2">
          <button
            className="btn btn-outline-secondary"
            onClick={fetchData}
            disabled={loading}
          >
            <i className={`ri-refresh-line ${loading ? "spin" : ""}`}></i> Refresh
          </button>
          {/* <Link to="/admin/add-hotel" className="btn btn-primary">+ Add Hotel</Link> */}
        </div>
      </div>

      {/* Search Box */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* <input type="text" placeholder="Search..." className="form-control search-input" value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} style={{ width: "200px" }} /> */}
        <div></div>
        <div>
          Items per page:
          <select
            className="form-select d-inline-block ms-2"
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1); // Reset to first page when limit changes
            }}
            style={{ width: "80px" }}
          >
            {[5, 10, 20, 50].map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="user-table table-responsive">
        <table className="table table-bordered dynamic-table">
          <thead>
            <tr>
              <th>#</th>
              <th style={{ cursor: "pointer" }} >Hotel Name</th>
              <th onClick={() => handleSort("_id")} style={{ cursor: "pointer" }} >Table ID {sortField === "_id" && (<i className={`ms-1 ri-arrow-${sortOrder === "asc" ? "up" : "down"}-line`}></i>)}</th>
              <th onClick={() => handleSort("tableNumber")} style={{ cursor: "pointer" }} >Table Number {sortField === "tableNumber" && (<i className={`ms-1 ri-arrow-${sortOrder === "asc" ? "up" : "down"}-line`}></i>)}</th>
              <th onClick={() => handleSort("name")} style={{ cursor: "pointer" }} >Table Name {sortField === "name" && (<i className={`ms-1 ri-arrow-${sortOrder === "asc" ? "up" : "down"}-line`}></i>)}</th>
              <th style={{ cursor: "pointer" }}>QR Image</th>
              <th>Status</th>
              <th>Regenerate <br></br>QRCode</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="text-center">Loading...</td>
              </tr>
            ) : users.length ? (
              users.map((user, index) => (
                <tr key={user._id}>
                  <td>{(page - 1) * limit + index + 1}</td>
                  <td>{user.hotelId?.name}</td>
                  <td>{user._id}</td>
                  <td>{user.tableNumber}</td>
                  <td>{user.name}</td>
                  <td>
                    {user.qrCode ? (
                      <img src={`${URL}/uploads/qrcodes/${user.qrCode}`} alt={user.name} width={100} height={100} />
                    ) : (
                      <span>No Image</span>
                    )}
                  </td>
                  {/* <td>{user.status}</td> */}
                  <td>{user.status === true ? "Active" : user.status === false ? "Inactive" : "N/A"}</td>
                  <td><i className="ri-recycle-line edit-icon" onClick={() => handleRegenerateQRCode(user)}></i></td>
                  <td key="actions">
                    <div className="action-icons">
                      <Link to={`/admin/${user.hotelId?._id}/tables/${user._id}`}><i className="ri-pencil-line edit-icon"></i></Link>
                      <i className="ri-delete-bin-line delete-icon" onClick={() => handleDeleteClick(user)}></i>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center">No users found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      {total > 0 && (
        <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
          <div>
            <span>
              Showing {Math.min((page - 1) * limit + 1, total)} -{" "}
              {Math.min(page * limit, total)} of {total} items
            </span>
          </div>
          <nav>
            <ul className="pagination mb-0">
              <li className={`page-item ${disablePrev ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => setPage(page - 1)}
                  disabled={disablePrev}
                >
                  &laquo;
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i}
                  className={`page-item ${page === i + 1 ? "active" : ""}`}
                >
                  <button className="page-link" onClick={() => setPage(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}
              <li className={`page-item ${disableNext ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => setPage(page + 1)}
                  disabled={disableNext}
                >
                  &raquo;
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}

      {/* Modal for Delete Confirmation */}
      {showDeleteModal && (
        <div className="modal fade show" tabIndex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">

              <div className="modal-body">
                <p>Please type <strong>"{showDeleteText}"</strong> to confirm the deletion.</p>
                <br />
                <input
                  type="text"
                  value={deleteText}
                  onChange={(e) => setDeleteText(e.target.value)}
                  placeholder="Type DELETE"
                  className="form-control" // Bootstrap form-control for input field styling
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-danger" onClick={handleDeleteConfirm} disabled={deleteText !== showDeleteText} >
                  Confirm Delete
                </button>
                <button className="btn btn-secondary" onClick={handleDeleteCancel}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Component;
